export const environment = {
  production: true,
  publicUrl: 'https://world-travel.uz',
  apiUrl: 'https://world-travel.uz:3001',
  panelUrl:'https://world-travel.uz:4200',
  websocketUrl: 'wss://world-travel.uz:9999',
  region: 'uz'
};
